import { __awaiter, __generator, __spreadArray } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = { class: "video-list" };
var _hoisted_2 = {
    key: 0,
    class: "spinner"
};
var _hoisted_3 = { key: 1 };
import { ref, onMounted, watch } from 'vue';
import axios from 'axios';
import AppVideoItem from '@/components/app-video-item.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-video-list',
    props: {
        channelId: {}
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var list = ref([]);
        var page = ref(1);
        var loading = ref(false);
        var error = ref('');
        var loadMore = ref(null);
        var channelPages = new Map(); // 存储每个频道的页码
        var fetchVideos = function (currentPage) { return __awaiter(_this, void 0, void 0, function () {
            var response, videos, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (loading.value)
                            return [2 /*return*/];
                        loading.value = true;
                        error.value = '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, axios.get('/videosList', {
                                params: {
                                    page: currentPage,
                                    pageSize: 14,
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        videos = response.data.data.data;
                        list.value = __spreadArray(__spreadArray([], list.value, true), videos, true);
                        page.value = currentPage + 1;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        error.value = '加载失败，请重试';
                        console.error('加载数据失败:', err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // 修改 watch
        watch(function () { return props.channelId; }, function (newId) {
            list.value = [];
            // 根据频道ID设置起始页码
            var startPage = parseInt(newId) + 1;
            page.value = startPage;
            fetchVideos(startPage);
        });
        // options是一个配置对象
        var options = {
            root: null,
            rootMargin: '35px',
            threshold: 0.3 // 目标元素可见部分达到30%时触发回调
        };
        // IntersectionObserver是一个构造函数，用于监听元素是否进入视口，自带节流功能
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && !loading.value) {
                    fetchVideos(page.value);
                    console.log('滚动');
                }
            });
        }, options);
        var createObserver = function () {
            if (loadMore.value) {
                observer.observe(loadMore.value); // 监听 loadMore 元素
            }
        };
        onMounted(function () {
            fetchVideos(page.value);
            createObserver();
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item) {
                    return (_openBlock(), _createBlock(AppVideoItem, {
                        key: item.id,
                        video: item
                    }, null, 8, ["video"]));
                }), 128)),
                _createElementVNode("div", {
                    ref_key: "loadMore",
                    ref: loadMore,
                    class: "load-more"
                }, [
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                        : _createCommentVNode("", true),
                    _cache[0] || (_cache[0] = _createTextVNode(" 让子弹飞一会 ")),
                    (error.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(error.value), 1))
                        : _createCommentVNode("", true)
                ], 512)
            ]));
        };
    }
});
